import { render, staticRenderFns } from "./tab-search.vue?vue&type=template&id=825d1ce8"
import script from "./tab-search.vue?vue&type=script&lang=js"
export * from "./tab-search.vue?vue&type=script&lang=js"
import style0 from "./tab-search.vue?vue&type=style&index=0&id=825d1ce8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports